import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './GT-Eesti-Text-Book.woff';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
    <Router>
        <Route component={App} />
    </Router>,
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js